// Ultimate Card Game (UCG) - Singleplayer Campaign Mission Definitions
//
// Minimal encounter schema (docs/game-design-singleplayer-kampagne.md
// Kapitel 5): enemies are spawned directly via Battlefield.spawnRaw() with
// a per-instance hpOverride, never played through CardSystem/BotAI - see
// Game.startCampaignMission() in js/main.js. hpOverride tunes this specific
// encounter only; it never touches the "Black Marine" card's own base hp
// (js/data/cards.js), so the same card entry stays reusable for a
// differently-tuned encounter later.

export const CAMPAIGN_MISSIONS = {
  m1_absprung: {
    id: 'm1_absprung',
    // Platzhalter-Hintergrund für "Plasma-Schrottfeld" - austauschbar,
    // sobald ein eigener Kampagnen-Hintergrund existiert.
    mapId: 'human',
    playerDeck: ['Shade'],
    // m1_forest_road now carries the full arc (Landung -> Fußmarsch ->
    // Ankunft bei den Marines) in einer durchgehenden, kamera-getrackten
    // Sequenz - kein separater preBattle-Jump-Cut mehr, siehe
    // js/data/campaignCutscenes.js.
    // No `victory` timeline here - the closing cutscene is built dynamically
    // from the Shade's actual end-of-fight position (Game.
    // _buildCampaignVictoryTimeline() in js/main.js), not pre-authored data.
    cutscenes: {
      intro: 'm1_forest_road'
    },
    enemies: [
      // 2 Treffer der Shade-Karte (2x25=50) überleben, der 3. (75) tötet -
      // siehe docs/game-design-singleplayer-kampagne.md Kapitel 9.3.
      { cardName: 'Black Marine', hpOverride: 60, x: 950, y: 300 },
      { cardName: 'Black Marine', hpOverride: 60, x: 1000, y: 360 }
    ],
    // Rein dekoratives Set-Dressing entlang des Fußmarsch-Pfads (docs/
    // singleplayer implementation soft-foraging-flamingo.md): ein liegender
    // Preserver Lock ohne Füße-Sprite, an dem der Shade kurz stehen bleibt,
    // bevor er die Gegner bemerkt. Gespawnt in startCampaignMission() als
    // permanent isCinematic:true-Einheit (nie per actorHide entfernt) -
    // js/engine/render/units.js's isCinematicProp-Zweig rendert nur den
    // Body-Layer, rotiert liegend, ohne Beine/HP-Bar.
    groundProps: [
      { cardName: 'Preserver Lock', x: 630, y: 318 }
    ]
  }
};
